export default __webpack_public_path__ + "static/empl-a6ae2f8a894962551253287939f34980.png";